export const REG_SUCCESS = 'REG_SUCCESS'
export const REG_ERROR = 'REG_ERROR'
export const RESET_REG_ERROR_STATUS = 'RESET_REG_ERROR_STATUS'
